import {
    HANDLE_CHANGE_PAIRING_SURVEY_DROPDOWN
} from "../../../constants";


export const handleChangePairingSurveyDropDown = (event) => {
    let value = { value: event }
    return {
        type: HANDLE_CHANGE_PAIRING_SURVEY_DROPDOWN,
        payload: value,
    };
};